<template>
  <card class="card">
    <template slot="header">
      <div class="d-flex">
        <div class="mr-auto p-2"><h4 class="card-title">{{ $t('accountAdditionalDetails.card.title') }}</h4></div>
        <create-account-additional-details-btn
          v-if="!accountAdditionalDetails && $auth.can({account_additional_details: 'create'}, 'permissions')"
          :account-id="this.$route.params.id"/>
        <edit-account-additional-details-btn
          v-if="accountAdditionalDetails && $auth.can({account_additional_details: 'update'}, 'permissions')"
          :current-details="accountAdditionalDetails"/>
        <delete-account-additional-details-btn
          class="ml-2"
          v-if="accountAdditionalDetails && $auth.can({account_additional_details: 'delete'}, 'permissions')"
          :details="accountAdditionalDetails"/>
        <base-button icon round type="neutral" size="sm" class="ml-2 zi_100" @click="fullShow = !fullShow"
                     :disabled="!accountAdditionalDetails">
          <span :class="{'mdi_icon':true, 'mdi':true, 'mdi-18px':true, 'mdi-unfold-more-horizontal':!fullShow, 'mdi-unfold-less-horizontal':fullShow}"/>
        </base-button>
      </div>
    </template>
    <div class="row">
      <div class="col-12" v-if="accountAdditionalDetails">
        <account-additional-details-table :details="accountAdditionalDetails" :full-show="fullShow"/>
      </div>
    </div>
  </card>
</template>
<script>
import CreateAccountAdditionalDetailsBtn from "./CreateAccountAdditionalDetailsBtn";
import EditAccountAdditionalDetailsBtn from "./EditAccountAdditionalDetailsBtn";
import DeleteAccountAdditionalDetailsBtn from "./DeleteAccountAdditionalDetailsBtn";
import {mapActions, mapState} from "vuex";
import AccountAdditionalDetailsTable from "@/components/AccountAdditionalDetails/AccountAdditionalDetailsTable";

export default {
  name: "AccountAdditionalDetails",
  components: {
    CreateAccountAdditionalDetailsBtn,
    EditAccountAdditionalDetailsBtn,
    DeleteAccountAdditionalDetailsBtn,
    AccountAdditionalDetailsTable,
  },
  data() {
    return {
      fullShow: false
    };
  },
  computed: {
    ...mapState({
      loading: state => state.account_additional_details.loading,
      error: state => state.account_additional_details.error,
      accountAdditionalDetails: state => state.account_additional_details.data,
    }),
  },
  methods: {
    ...mapActions(['LoadAccountAdditionalDetails']),
  },
  mounted() {
    this.LoadAccountAdditionalDetails(this.$route.params.id)
  }
};
</script>
